import styled from 'styled-components';
import { Label } from '../../styles';

export const NeutralLabel = styled(Label)`
  color: #7c7c7c;
`;
